import { useEffect } from "react";

import {
    AnchorContentsResponse,
    PaidLandingPersonaTypes
} from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePageProps } from "./jira-software-page";
import { JiraSoftwarePagePaidLpJswAnchor } from "./paid-lp-jsw-anchor";

export interface JiraSoftwarePageAnchorLpJswDesignProps
    extends JiraSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
}

export const JiraSoftwarePageAnchorLpJswDesign = (
    pageProps: JiraSoftwarePageAnchorLpJswDesignProps
) => {
    const pageId = "anchor-lp-jsw-team-design";
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationJiraExperiment);

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);

    return (
        <JiraSoftwarePagePaidLpJswAnchor
            {...pageProps}
            pageId={pageId}
            persona={pageProps.persona as PaidLandingPersonaTypes}
            pageVariant="design"
        />
    );
};
